import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import axios from "axios";
import { ArrowLeft } from "lucide-react";
import Reveal from "@/components/Reveal";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const BlogPost = () => {
  const { slug } = useParams();
  const [post, setPost] = useState(null);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    let cancel = false;
    (async () => {
      try {
        const { data } = await axios.get(`${API}/blog/${slug}`);
        if (!cancel) setPost(data);
      } catch {
        if (!cancel) setNotFound(true);
      }
    })();
    return () => { cancel = true; };
  }, [slug]);

  if (notFound) {
    return (
      <section className="pt-40 pb-24 min-h-screen">
        <div className="max-w-[900px] mx-auto px-6 md:px-10 text-center">
          <div className="font-mono-tech text-[11px] tracking-[0.22em] uppercase text-[var(--gold)]">404</div>
          <h1 className="mt-4 font-display text-5xl text-white">Entry not found.</h1>
          <Link to="/blog" className="btn-gold mt-10 inline-flex"><span>Back to Journal</span></Link>
        </div>
      </section>
    );
  }

  if (!post) {
    return (
      <section className="pt-40 pb-24 min-h-screen">
        <div className="max-w-[900px] mx-auto px-6 md:px-10 font-mono-tech text-white/40 text-sm">Loading…</div>
      </section>
    );
  }

  return (
    <article className="pt-32 pb-24" data-testid={`blog-post-${slug}`}>
      <div className="relative h-[60vh] w-full overflow-hidden">
        <img src={post.cover} alt="" className="absolute inset-0 w-full h-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/40 to-black" />
      </div>

      <div className="max-w-[820px] mx-auto px-6 md:px-10 -mt-40 relative z-10">
        <Reveal>
          <Link to="/blog" className="inline-flex items-center gap-2 font-mono-tech text-[11px] tracking-[0.22em] uppercase text-[var(--gold)] mb-6">
            <ArrowLeft size={14} /> Journal
          </Link>
          <div className="flex items-center gap-4 font-mono-tech text-[10px] tracking-[0.22em] uppercase text-white/45 mb-6">
            <span className="text-[var(--cyan)]">{post.category}</span>
            <span>{post.read_time}</span>
            <span>{post.date}</span>
          </div>
          <h1 className="font-display text-4xl md:text-6xl tracking-tight text-white leading-[1.0]">{post.title}</h1>
          <p className="mt-6 font-serif-display text-2xl text-[var(--gold)]">{post.excerpt}</p>
        </Reveal>

        <Reveal delay={0.1}>
          <div className="mt-12 text-white/75 leading-[1.85] text-lg space-y-6 whitespace-pre-line">
            {post.body}
          </div>
        </Reveal>
      </div>
    </article>
  );
};

export default BlogPost;
